// Vendor Libs
import {chain, cloneDeep, set} from 'lodash';

const initialState = {
    fetching: false,
    fetched: false,
    error: null,
    query: {
        page: 1,
        pageLimit: 20,
        sort: [],
    },
    queryUpdated: false,
    searchData: {
        content: [],
        first: true,
        last: true,
        number: 0,
        numberOfElements: 0,
        size: 10,
        sort: null,
        totalElements: 0,
        totalPages: 1,
    },
    filter: {
        actionId: null,
        targets: [],
    },
};

const customInitialState = {
    genres: set(getInitialState(), 'query.pageLimit', 1000),
    networks: set(getInitialState(), 'query.sort', [
        {
            column: 'name',
            order: 'asc',
        },
    ]),
    massActions: set(getInitialState(), 'query.sort', [
        {
            column: 'lastUpdated',
            order: 'desc',
        },
    ]),
    moviesAndProgramsMappingEpisodes: set(getInitialState(), 'query.sort', [
        {
            column: 'originalAirDate',
            order: 'desc',
        },
    ]),
    networksMapping: chain(getInitialState())
        .set('query.pageLimit', 2500)
        .set('query.sort', [{column: 'name', order: 'asc'}])
        .value(),
    providers: set(getInitialState(), 'query.sort', [
        {
            column: 'name',
            order: 'asc',
        },
    ]),
    providersSelect: set(getInitialState(), 'query.pageLimit', 1000),
    unmappedMediaItems: set(getInitialState(), 'query.sort', [
        {
            column: 'sortablePriority',
            order: 'asc',
        },
        {
            column: 'offerings.startDate',
            order: 'asc',
        },
    ]),
    users: set(getInitialState(), 'query.sort', [
        {
            column: 'clientId',
            order: 'asc',
        },
    ]),
    violations: set(getInitialState(), 'query.sort', [
        {
            column: 'lastUpdated',
            order: 'desc',
        },
    ]),
};

function getInitialState() {
    return cloneDeep(initialState);
}

export default function getServiceInitialState(servicesDataKey) {
    return cloneDeep(customInitialState[servicesDataKey] || getInitialState());
}
